/**
 * Cleans up whitespace characters (space, tabs, new lines, etc) from given string and replaces
 * them with a single space
 * @name removeWhitespaceFromString
 * @function
 * @param {String} input
 */
export const removeWhitespaceFromString = (input) => input.replace(/\s+/g, " ");
